import brand from "../config/brand";

export const AppLoader = (props: { message: string }) => {
  return (
    <div className="flex flex-col items-center justify-center mt-20 1080p:mt-24 4k:mt-32 8k:mt-40">
      <img
        src={brand.loadingImageUrl}
        alt={brand.companyName}
        className="w-20 h-20 1080p:w-24 1080p:h-24 4k:w-32 4k:h-32 8k:w-40 8k:h-40 animate-pulse"
      />
      <div className="w-auto text-center text-gray-500 dark:text-gray-100 mt-8">
        <p>
          <b className="text-lg 1080p:text-xl 4k:text-3xl 8k:text-5xl font-bold">
            {props.message || "Loading..."}
          </b>
        </p>
      </div>
    </div>
  );
};
